import Form from "./Form";
import useFurtherDetails from "./hooks/useFurtherDetails";

export const FurtherDetails: React.FC = () => {
  const { ...props } = useFurtherDetails();

  return <Form {...props} />;
};
export default FurtherDetails;
